import { helper } from "lib/helper";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardFooter,
  CardHeader,
  Container,
  Row,
  Table,
  Input,
  FormGroup,
  Col,
  Label, // Import Input for search
} from "reactstrap";
// core components
import TablePagination from "views/components/TablePagination";
import img from '../../assets/img/brand/goodybuddy_short.png';
import { filterItems } from "lib/helper"; // Import the filtering function
import * as XLSX from 'xlsx'; // Import XLSX for exporting to Excel
import ExportButton from "components/ExportButton";
import adminModel from "models/admin.model";
import Loader from "components/loader/Loader";

// Sample data for the categories page with numeric priority
const categoriesData = [
  {
    "_id": "1",
    "name": "Electronics",
    "priority": 1, // Numeric priority
    "icon": img, // Assuming path to an image
  },
  {
    "_id": "2",
    "name": "Fashion",
    "priority": 2, // Numeric priority
    "icon": img,
  },
  {
    "_id": "3",
    "name": "Groceries",
    "priority": 3, // Numeric priority
    "icon": img,
  },
  {
    "_id": "4",
    "name": "Books",
    "priority": 2, // Numeric priority
    "icon": img,
  },
  // Add more categories as needed
];

const AllCategory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [categoriesList, setCategoriesList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState(""); 
  const navigate = useNavigate();

  const getExperienceCategory = async () => {
    setIsLoading(true);
    try {
      const response = await adminModel.getExperienceCategory()
      setCategoriesList(response.data)
      console.log(response);
      setIsLoading(false);
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.message || 'Something went wrong', "warning");
      setIsLoading(false);
    }
  }




  // Function to handle category deletion
  const handleDelete = (id) => {
    try {
      helper.sweetalert
      .confirm("Are you sure you want to delete this category?", "info", true)
      .then((result) => {
          setIsLoading(true);
          if (result.isConfirmed) {
            try {
              setIsLoading(true);
              const response = adminModel.deleteCategory(id);
              const updatedList = categoriesList.filter((item) => item._id !== id);
              setCategoriesList(updatedList);
              // console.log(updatedList)
              helper.sweetalert.toast("Category deleted successfully!");
              setIsLoading(false);
            } catch (error) {
              setIsLoading(false);
              helper.sweetalert.toast(error.response?.data?.message || 'Something went wrong', "warning ");
            }
          }
          setIsLoading(false);
        });
    } catch (error) {
      helper.sweetalert.toast(error.response?.data?.message || 'Something went wrong', "warning");
      setIsLoading(false)
    }
  };

  // Function to handle edit
  const handleUpdate = (id) => {
    navigate(`/admin/edit-experience-categories/${id}`);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); 
  };

  // Filter categories based on the search query
  const filteredCategoriesList = filterItems(categoriesList, searchQuery, ['name' , 'priority']); // Filter by category name

  const columnsConfig = [
    {
      label: "S.No",
      getValue: (item, index, currentPage, perPage) => ((currentPage - 1) * perPage) + index + 1,
    },
    {
      label: "Category Name",
      getValue: (item) => item.name,
    },
    {
      label: "Priority",
      getValue: (item) => item.priority,
    },
  ];


  useEffect(() => {
    getExperienceCategory()
  },[]);

  return isLoading ? <Loader/> :(
    <>
      <Container className="pt-6" fluid>
        {!isLoading && (
          <Row>
            <div className="col pl-0 pr-0">
              <Card className="shadow">
                <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                  <h3 className="mb-0">All Tagss</h3>
                  <div className="d-flex align-items-center">
                    <Input
                      type="text"
                      placeholder="Search by Category Name , Priority..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      style={{ width: '300px', marginRight: '10px' }} // Optional: adjust width
                    />
                    <ExportButton data={filteredCategoriesList} columnsConfig={columnsConfig}/>
                  </div>
                </CardHeader>
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">S.No</th>
                      <th scope="col">Tag Name</th>
                      <th scope="col">Priority</th>
                      <th scope="col">Icon / Image</th>
                      <th scope="col">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredCategoriesList.slice((currentPage - 1) * perPage, currentPage * perPage).map((item, index) => {
                      return (
                        <tr key={item._id} className="">
                          <td className="px-4 py-1">{((currentPage - 1) * perPage) + index + 1}</td>
                          <td className="px-4 py-1">{item?.name}</td>
                          <td className="px-4 py-1">{item?.priority}</td> {/* Display numeric priority */}
                          <td className="px-4 py-1">
                            <img
                              src={item?.image}
                              alt={item?.name}
                              style={{ width: "40px", height: "40px" }}
                            />
                          </td>
                          <td className="px-4 py-1">
                            <Button
                              color="warning"
                              size="sm"
                              className="mr-2"
                              onClick={() => handleUpdate(item._id)}
                            >
                              <i class="fa-regular fa-pen-to-square"></i>
                            </Button>
                            <Button
                              color="danger"
                              size="sm"
                              onClick={() => handleDelete(item._id)}
                            >
                              <i class="fa-solid fa-trash"></i>
                            </Button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
                <CardFooter className="py-4">
                  <TablePagination
                    totalPages={Math.ceil(filteredCategoriesList.length / perPage)}
                    currentPage={currentPage}
                    onPageChange={handlePageChange}
                    pageUrl="/admin/categories?"
                  />
                </CardFooter>
              </Card>
            </div>
          </Row>
        )}
      </Container>
    </>
  );
};

export default AllCategory;
